import {skipToken, useQuery} from '@tanstack/react-query'

import {getCustomerLastRates} from './api'
import {jobEntryKeys} from './query-keys'

export function useCustomerLastRates(customerId: string | null) {
    return useQuery({
        queryKey: jobEntryKeys.lastRates(customerId ?? ''),
        queryFn: customerId ? () => getCustomerLastRates(customerId) : skipToken,
    })
}
